import type { IPagination } from 'BreetHelpers';

export interface PaginationProps extends Omit<IPagination, 'pageLimit'> {
	onPageChange?: (state: Partial<IPagination>) => void;
	className?: string;
	isLoading?: boolean;
	pageLimit?: number;
	docItemsIdentifier?: string;
}

export interface IPageLimitList {
	pageLimit: number;
	onLimitChange: (limit: number) => void;
	isLoading?: boolean;
}

export const pageLimitOptions = [10, 25, 50, 100, 200];

export const getDocItemsIdentifier = (count: number, identifier?: string): string | undefined => {
	if (!identifier || count !== 1) return identifier;

	if (/(?:ss|sh|ch|x|z|s)es$/i.test(identifier)) return identifier.replace(/es$/i, '');
	if (/[^aeiou]ies$/i.test(identifier)) return identifier.replace(/ies$/i, 'y');
	if (/[^s]s$/i.test(identifier)) return identifier.replace(/s$/i, '');

	return identifier;
};

export interface IPaginationShort {
	currentPage: number;
	pageLimit: number;
	totalDocItems: number;
	isLoading?: boolean;
	onPageChange?: (state: Partial<IPagination>) => void;
}
